<atx-avatar
  [fullName]="contact?.displayName"
  [image]="contact?.imageLink"
  size="xxl"
></atx-avatar>
<div class="d-flex flex-column my-4 align-items-center">
  <strong class="contact-name">{{ contact?.displayName }}</strong>
  <span
    i18n="Connect|Incoming call text@@connectIncomingCallText"
    class="text-muted"
    >is calling you</span
  >
</div>

<div class="d-flex">
  <button
    (click)="accept.emit()"
    type="button"
    class="btn btn-success rounded-pill d-flex align-items-center flex-shrink-0"
    data-e2e="connect-accept-call"
  >
    <fa-icon [icon]="['fas', 'video']" size="xs"></fa-icon>
    <span
      i18n="Connect|Call accept@@connectCallNotificationAccept"
      class="ml-3 flex-shrink-0"
      >Accept</span
    >
  </button>
  <button
    (click)="decline.emit(declineReasons.MANUAL)"
    type="button"
    class="
      btn
      ml-3
      btn-danger
      rounded-pill
      d-flex
      align-items-center
      d-flex
      align-items-center
      flex-shrink-0
    "
    data-e2e="connect-decline-call"
  >
    <fa-icon [icon]="['fas', 'phone-slash']" size="xs"></fa-icon>
    <span
      i18n="Connect|Call decline@@connectCallNotificationDecline"
      class="ml-3"
      >Decline</span
    >
  </button>
</div>
